import equityPayload from "@/payloads/equity.json";
import equityChangesPayload from "@/payloads/equity_changes.json";
import equityCoraxChangesPayload from "@/payloads/equity_corax_changes.json";

export default {
    equityReferenceFieldData(){
      const refData = this.refFieldsArray
      const rows = []
      let columns = []
      var i = 0
      for(let data in refData){
        columns.push(data)
        columns.push(refData[data])
        if (i % 2 === 1) {
          rows.push(columns)
          columns = []
        }
        i = i+1
      }
      if (columns.length > 0 && rows[rows.length - 1] != columns) {
        rows.push(columns)
      }
      return rows
    },
    resetPayload(){
      var payload = equityPayload;
      const arr = payload["dataConditions"]["conditions"];
      arr[0]["fieldValue"] = "EMPTY"
      arr[0]["fieldOperator"] = "1"
      arr[3]["fieldValue"] = "EMPTY"
      arr[3]["fieldOperator"] = "1"
      if(arr.length > 5){
        arr.pop();
      }
      var payload2 = equityChangesPayload;
      const arr2 = payload2["dataConditions"]["conditions"];
      arr2[0]["fieldValue"] = "EMPTY"
      arr2[0]["fieldOperator"] = "1"
      arr2[3]["fieldValue"] = "EMPTY"
      arr2[3]["fieldOperator"] = "1"
      if(arr2.length > 8){
        arr2.pop();
      }
    },
    saveSelectedValues () {
      this.resetPayload();
      const fileCodes = {
        "HK": "1|66|3200|3508",
        "JP": "2|6|4|7",
        "SG": "27",
        "TH": "17|760|3953",
        "US": "77|1174|1175|81|79",
        "AU": "66",
        "CA": "82|4912|1676",
        "FR": "52|3929",
        "GE": "1693|62|60|186",
        "IN": "47",
        "LN": "43|691|1144|1215|482|1560",
        "PH": "250",
        "SW": "477",
        "NL": "50",
        "IND": "190|423"
      };
      const search = this.$refs.search.value
      const crite = this.$refs.criteria.value
      this.selectedDate = this.$refs.datePicker.value
      let d = new Date(this.selectedDate)
      d.setDate(d.getDate() + 6)
      if(d.getTime() < new Date().getTime()){
        this.todayDate = d.toJSON().slice(0, 10)
      }else{
        this.todayDate = new Date().toJSON().slice(0, 10)
      }
      this.selectedMarket = this.$refs.markets.values
      this.highlightColor = this.$refs.highlightColor.value
      this.fontColor = this.$refs.fontColor.value
      this.requestType = "equity"
      let payload = equityChangesPayload
      let toggle = document.getElementById("changes-toggle")
      let dataToggle = document.getElementById("change-data-toggle")
      if(toggle.checked){
        if(dataToggle.checked){
          payload = equityChangesPayload
          payload["dateConditions"][0]["startDate"] = this.selectedDate
          payload["dateConditions"][0]["endDate"] = this.todayDate
          payload["dateConditions"][1]["startDate"] = this.selectedDate
          payload["dateConditions"][1]["endDate"] = this.todayDate
        }else{
          payload = equityCoraxChangesPayload
          payload["dateConditions"][0]["startDate"] = this.selectedDate
          payload["dateConditions"][0]["endDate"] = this.todayDate
          payload["dateConditions"][1]["startDate"] = this.selectedDate
          payload["dateConditions"][1]["endDate"] = this.todayDate
          payload["dateConditions"][2]["startDate"] = this.selectedDate
          payload["dateConditions"][2]["endDate"] = this.todayDate
          payload["dateConditions"][3]["startDate"] = this.selectedDate
          payload["dateConditions"][3]["endDate"] = this.todayDate
        }
      }else{
        payload = equityPayload
        payload["dateConditions"][0]["startDate"] = this.selectedDate
        payload["dateConditions"][0]["endDate"] = this.todayDate
      }
      document.getElementById("export-toggle-btn").disabled = true
      document.getElementById("export-drpdwn").disabled = true
      document.getElementById("export-btn").disabled = true
      if(search.length>0 && crite != ""){
        toggle.checked = false
        payload = equityPayload
        payload["dateConditions"][0]["startDate"] = this.selectedDate
        payload["dateConditions"][0]["endDate"] = this.todayDate
        if(crite == "ric"){
          payload["dataConditions"]["conditions"][0]["fieldValue"] = search
          payload["dataConditions"]["conditions"][0]["fieldOperator"] = "0"
        }else{
          payload["dataConditions"]["conditions"].push(
            {
                "tableName": "report_type_int",
                "fieldName": crite,
                "fieldValue": search,
                "fieldOperator": "0"
            }
          )
        }
      }
      if(this.selectedMarket.length>0){
        var fileCodesString = "";
        for(let market of this.selectedMarket){
          fileCodesString += fileCodes[market]+"|"
        }
        fileCodesString = fileCodesString.slice(0,-1);
        payload["dataConditions"]["conditions"][3]["fieldValue"] = fileCodesString;
        payload["dataConditions"]["conditions"][3]["fieldOperator"] = "0"
      }
      this.postQueryExecution(payload)
    },
}